var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000006224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cancel",
    d: "M7 0.875C3.61287 0.875 0.875 3.61287 0.875 7C0.875 10.3871 3.61287 13.125 7 13.125C10.3871 13.125 13.125 10.3871 13.125 7C13.125 3.61287 10.3871 0.875 7 0.875ZM9.63375 9.63375C9.57709 9.69053 9.50978 9.73558 9.43568 9.76631C9.36159 9.79705 9.28216 9.81287 9.20194 9.81287C9.12172 9.81287 9.04229 9.79705 8.96819 9.76631C8.8941 9.73558 8.82679 9.69053 8.77013 9.63375L7 7.86363L5.22988 9.63375C5.11535 9.74827 4.96002 9.81261 4.79806 9.81261C4.6361 9.81261 4.48077 9.74827 4.36625 9.63375C4.25173 9.51923 4.18739 9.3639 4.18739 9.20194C4.18739 9.12174 4.20318 9.04233 4.23387 8.96824C4.26456 8.89415 4.30954 8.82683 4.36625 8.77013L6.13638 7L4.36625 5.22988C4.25173 5.11535 4.18739 4.96002 4.18739 4.79806C4.18739 4.6361 4.25173 4.48077 4.36625 4.36625C4.48077 4.25173 4.6361 4.18739 4.79806 4.18739C4.96002 4.18739 5.11535 4.25173 5.22988 4.36625L7 6.13638L8.77013 4.36625C8.82683 4.30954 8.89415 4.26456 8.96824 4.23387C9.04233 4.20318 9.12174 4.18739 9.20194 4.18739C9.28213 4.18739 9.36154 4.20318 9.43563 4.23387C9.50972 4.26456 9.57704 4.30954 9.63375 4.36625C9.69046 4.42296 9.73544 4.49028 9.76613 4.56437C9.79682 4.63846 9.81261 4.71787 9.81261 4.79806C9.81261 4.87826 9.79682 4.95767 9.76613 5.03176C9.73544 5.10585 9.69046 5.17317 9.63375 5.22988L7.86363 7L9.63375 8.77013C9.8665 9.00288 9.8665 9.39487 9.63375 9.63375Z",
    fill: "#D81717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketCancel);
export default __webpack_public_path__ + "static/media/ticket-cancel.3e7499a5319c4a2a7eff95b95f338831.svg";
export { ForwardRef as ReactComponent };